// eslint-disable-next-line no-unused-vars
import { Plugin } from "./Main";

interface ITool{
    showMenu: (itemId:string) => boolean;
    action: (itemId:string) => void;
    title: string;
}
interface ITableField { content: string, comment?:string, subtable?:string}
export class Tool{
    conditionTemplateField: XRFieldTypeAnnotated;
    conditionParamsTemplateField: XRFieldTypeAnnotated;
    
   
    getListTools(): ITool[] {
        let tools = [];

        tools.push({
            "title": "Add multiple BLOCKs/TRACEs/FIELDs",
            "action": (itemId: string) => {

                let st = new ItemSelectionTools();
                // let user select the items
                let field = IC.getFieldByName("TABLE", "Item Rows - Cells");

                if (itemId.indexOf("SUBTABLE-") == 0) {
                    field = IC.getFieldByName("SUBTABLE", "Columns");
                }

                st.showDialog({
                    selectMode:SelectMode.items,
                    linkTypes: [{type: "BLOCK"} , {type: "TRACES"} , {type: "FIELDS"}],
                    selectionChange: function (selection: IReference[]) {
                        
                        let valueAsString = app.getFieldValue(field.id);
                        let rows:ITableField[] = JSON.parse(valueAsString);
                        for (let block of selection) { 
        
                            rows.push( {content:block.to });
                        }
                        matrixApplicationUI.lastMainItemForm.getControlById(field.id).getController().setValue(JSON.stringify(rows));
                        app.saveAsync(true);


                    },
                    getSelectedItems: function () {
                        return [];
                    }
                });
             },
            "showMenu": (itemId: string) =>
                // Only for table  and subtable
                itemId.indexOf("TABLE-") != 1 && itemId.indexOf("F-")!==0 
        });

        tools.push({
            "title": "Add  SUBTABLE",
            "action": (itemid: string) => {

                let st = new ItemSelectionTools();

                let field = IC.getFieldByName("TABLE", "Item Rows - Cells");

                if (itemid.indexOf("SUBTABLE-") == 0) {
                    field = IC.getFieldByName("SUBTABLE", "Columns");
                }   

                // let user select the items
                st.showDialog({
                    selectMode: SelectMode.singleItem,
                    linkTypes: [{ type: "SUBTABLE" }],
                    selectionChange: async function (selection: IReference[]) {
                        
                        if (selection.length != 1)
                            return;
                       
                        let valueAsString = app.getFieldValue(field.id);
                        let existingRows: ITableField[] = JSON.parse(valueAsString);
                        
                        // Check if there is already a subtable
                        let existingSubTable = undefined
                        for (let row of existingRows) { 
                            if (row.content.indexOf("SUBTABLE-") == 0) { 
                                existingSubTable = row.content;
                            }
                        }
                        if (existingSubTable && existingSubTable === selection[0].to ) {
                            ml.UI.showError("There is already a subtable in this table", "Remove the subtable " + existingSubTable + " first");
                            return;
                        }

                        let subtableItem: IItem = await app.getItemAsync(selection[0].to);
                        let subtableRowField = IC.getFieldByName("SUBTABLE", "Columns");
                        let subTableRow: ITableField[] = JSON.parse(subtableItem[subtableRowField.id]);
                        let i = 1;
                        for (let row of subTableRow) { 
                            existingRows.push({ content: selection[0].to, comment: app.getItemTitle(row.content) + " (" + (row.comment ?? "") + ")", subtable: "c" + i });
                            i++;
                        }
                        
                        matrixApplicationUI.lastMainItemForm.getControlById(field.id).getController().setValue(JSON.stringify(existingRows));
                        app.saveAsync(true);


                    },
                    getSelectedItems: function () {
                        return [];
                    }
                });
             },
            "showMenu": (itemId: string) =>
                // Only for table  and subtable
                itemId.indexOf("TABLE-") != 1  && itemId.indexOf("F-")!==0 
        });

        tools.push({
            "title": "Generate BLOCKs for project",
            "action": (folderId: string) => {
              
                let parameter = {project:undefined,cat:undefined};
                
                let dlg = $("<div>").appendTo($("body"));
                let buttons = [{
                    text: 'Ok',
                    class: 'btnDoIt generateBlocks',
                    click:  async ()=> {
                        if (parameter.project)
                        {
                            ui.append(ml.UI.getSpinningWait());
                            await this.generateBlocks(parameter.project, folderId);
                        }
                        dlg.remove();

                        return true;
                }
                }];
                let ui = $("<div>");
                ml.UI.addDropdownToValue(ui, "Select a project", parameter, "project",
                    matrixSession.getProjectList(true).map(p => { return { id: p.shortLabel, label:p.shortLabel + " - " +  p.label } }), false, false, () => { }, "Select a project");
                
                ml.UI.showDialog(dlg, "Generate BLOCKs", ui, 800, 400,
                buttons,
                UIToolsEnum.Scroll.Vertical,
                true,
                true,
                () => {
                        dlg.remove();
                },
                () => {
                },
                () => { }
            );

             },
            "showMenu": (itemId: string) =>
                // Only for Block folder
                itemId.indexOf("F-BLOCK-") ==0 
        });

        return tools;
    }
    
    blockItemField: XRFieldTypeAnnotated;



    async generateBlocks(project: string, folderId: string) {


        $(".generateBlocks").remove();
        let projectInfo:XRProjectInfo = <XRProjectInfo> await restConnection.getServer(project);
        let update: IItemPut = { title: project, children: [] };
        
        this.blockItemField = IC.getFieldByName("BLOCK", "item or folder");
        this.conditionTemplateField = IC.getFieldByName("BLOCK", "condition");
        this.conditionParamsTemplateField = IC.getFieldByName("BLOCK", "condition params");

      
        let itemList = [];

        let result =   await app.createItemOfTypeAsync("BLOCK", update, "add", folderId);
        let projectFolderId = result.item.id;
        for (let category of projectInfo.categoryList.categoryExtended) {
            
            if(["REPORT","FOLDER","DOC","SIGN"].indexOf(category.category.shortLabel) != -1)
                continue;

            let newCatFolder: IItemPut = { title: project + " - " + category.category.shortLabel, children: [] };
            result = await app.createItemOfTypeAsync("BLOCK", newCatFolder, "add", projectFolderId);
            let catFolderId = result.item.id;


            result = await this.createItem(projectInfo.shortLabel + " - " + category.category.shortLabel + " - title" , catFolderId,
            this.blockTitleTemplate(),
            this.conditionTemplate(),
            this.conditionParamsTemplate(category.category.shortLabel));
            itemList.push(result.item.id);
            

            for (let field of category.fieldList.field) {
                switch (field.fieldType) {
                    case "risk2":
                        result = await this.createItem(projectInfo.shortLabel + " - " + category.category.shortLabel + " - " + field.label , catFolderId,
                            this.blockItemFieldTemplate(field.label),
                            this.conditionTemplate(),
                            this.conditionParamsTemplate(category.category.shortLabel));
                           itemList.push(result.item.id);
                           itemList.push(...await this.generateRiskBlocks(projectInfo, category.category.shortLabel, field, catFolderId));
                        break;
                    default:
                        result = await this.createItem(projectInfo.shortLabel + " - " + category.category.shortLabel + " - " + field.label, catFolderId,
                            this.blockItemFieldTemplate(field.label),
                            this.conditionTemplate(),
                            this.conditionParamsTemplate(category.category.shortLabel));
                         itemList.push(result.item.id);
                        break
                    
                }
               
                
            }
        }   
 
        let p: Promise<string> = new Promise((resolve, reject) => {
            setTimeout(() => { 
                if (itemList.length > 0) {
                    MR1.onItemDisplayed().subscribe(this, (args) => { 
                        console.log("onItemDisplayed " + itemList.length + "- " +args.item.id);
                        setTimeout(() => {
                            app.saveAsync(true);
                            if (itemList.length)
                            {
                                let item = itemList.pop();
                                app.loadProject("PRINT", item);     
                            }  
                            else {
                                resolve("done");
                                window.location.reload();
                            }
                       },100)
                        
                    });
                    let item = itemList.pop();
                    app.loadProject("PRINT", item);
                
                }
            }, 100);
        });
        await p;

    }
    async generateRiskBlocks(projectInfo: XRProjectInfo, category: string, field: XRFieldType, catFolderId: string): Promise<string[]> {

        let itemList:string[] = [];
        // render a dummy risk ui item to get whole attribute list
        let riskConfig = projectInfo.settingList.find((value, index) => { return value.key == "riskConfig" });
        let riskConfigJson: IRiskConfig = {} || (riskConfig ? JSON.parse(riskConfig.value) : {});
        if (field.parameter != "") {
            riskConfigJson = JSON.parse(field.parameter).riskConfig;
        }
        let dummy = $("<div>");
        dummy.riskCtrl2({
            controlState: ControlState.Print,
            canEdit: false,
            help: "",
            fieldValue: JSON.stringify({}),
            parameter: {
                riskConfig: riskConfigJson,
                showAttributeNames: true,
                forceAfterWeightsInPrint: true
            }
        });

        console.log(dummy.html());
        for (let item of dummy.find(".debug")) {
            let attribute = $(item).text();
            let result = await this.createItem( projectInfo.shortLabel + " - " + category + " - " + field.label + " - " + attribute, catFolderId,
                this.blockItemFieldTemplateRisk(field.label,attribute),
                this.conditionTemplate(),
                this.conditionParamsTemplate(category));
            itemList.push(result.item.id);
        }
        return itemList;
    }
    
   
    private async createItem(title:string, catFolderId: string,
                    blockItemValue: string,
                    conditionValue:string, conditionParamsValue: string) {
        let fieldItem: IItemPut = { title: title };
        let result = await app.createItemOfTypeAsync("BLOCK", fieldItem, "add", catFolderId);
        result.item["fx" + this.blockItemField.id] = blockItemValue;
        result.item["fx" + this.conditionTemplateField.id] = conditionValue; 
        result.item["fx" + this.conditionParamsTemplateField.id] = conditionParamsValue;  

        await app.updateItemInDBAsync(result.item, "update");
        return result;
    }

    // Not needed for this plugin
    showMenu(itemId:string) {
        return true;
    }

    /** callback when user executes the custom the menu entry added to items or folders 
     * 
     * */ 
    menuClicked(itemId:string) {
        /* Insert code here */
    }

    /* templates */
    blockTitleTemplate(){ return `<span class="mceNonEditable execPrintFunction" title="{&quot;renderFunction&quot;:&quot;link&quot;}">Hyperlink to item</span> <span class="mceNonEditable execPrintFunction" title="{&quot;renderFunction&quot;:&quot;title&quot;}">Title of item</span>`}
    blockItemFieldTemplate(fieldName: string) { return `\u003cspan class\u003d"mceNonEditable execPrintFunction" title\u003d"{\n  \u0026quot;renderFunction\u0026quot;:\u0026quot;fielditemcontent\u0026quot;,\n  \u0026quot;fieldName\u0026quot;:\u0026quot;${fieldName}\u0026quot;\n}\n"\u003eContents of a field\u003c/span\u003e\u0026nbsp;` }
    blockItemFieldTemplateRisk(fieldName: string, attribute: string) {
        return `<span class="mceNonEditable execPrintFunction" title="{
            &quot;renderFunction&quot;:&quot;fielditemcontent&quot;,
            &quot;fieldName&quot;:&quot;${fieldName}&quot;,
            &quot;attribute&quot;:&quot;${attribute}&quot;
          }">Contents of a field</span>` }
    
    
    conditionTemplate() { return "iscategory"; }
    conditionParamsTemplate(cat:string) { return `{  "categories":["${cat}"]}`; }

}
/*


{
  "title": "BASE_DEEP_TRACES - Level A - Description",
  "itemRef": "BLOCK-59-v3",
  "folderRef": "F-BLOCK-15",
  "fieldValList": {
    "fieldVal": [
      {
        "id": 1062,
        "value": "iscategory"
      },
      {
        "id": 1063,
        "value": "{  \"categories\":[\"REQ\"]}"
      },
      {
        "id": 1064,
        "value": "\u003cspan class\u003d\"mceNonEditable execPrintFunction\" title\u003d\"{\n  \u0026quot;renderFunction\u0026quot;:\u0026quot;fielditemcontent\u0026quot;,\n  \u0026quot;fieldName\u0026quot;:\u0026quot;Description\u0026quot;\n}\n\"\u003eContents of a field\u003c/span\u003e\u0026nbsp;"
      },
      {
        "id": 1065,
        "value": "{\n  \"uid\": \"BLOCK-59\",\n  \"name\": \"BASE_DEEP_TRACES - Level A - Description\",\n  \"help\": \"\",\n  \"render\": \"$[  \\\"renderFunction\\\":\\\"fielditemcontent\\\",  \\\"fieldName\\\":\\\"Description\\\"]$\u0026nbsp;\",\n  \"condition\": \"iscategory\",\n  \"params\": {\n    \"categories\": [\n      \"REQ\"\n    ]\n  }\n}"
      }
    ]
  },
  "labels": [],
  "maxVersion": 3,
  "disabled": 0,
  "isFolder": 0,
  "itemId": 25668,
  "modDate": "2022-10-20T16:56:48.258Z",
  "modDateUserFormat": "2022/10/20 16:56:48",
  "isUnselected": 0
}

*/